import { Component, Input, OnInit } from '@angular/core';
import { ActionItem, HttpService } from '@sdbn/appclient';
import { AsyncSubject } from 'rxjs';
import { TransportCreationProfileSight } from '../action-tablet-transport-creation-profile.model';
import { environment } from 'src/environments/environment';
import { DialogService } from '@sdbn/common';

@Component({
  selector: 'app-action-tablet-transport-creation-profile-item',
  templateUrl: './action-tablet-transport-creation-profile-item.component.html',
  styleUrls: ['./action-tablet-transport-creation-profile-item.component.scss']
})
export class ActionTabletTransportCreationProfileItemComponent implements OnInit {

  @Input() actionItem: ActionItem;

  profiles = new Array<TransportCreationProfileSight>();

  constructor(
    private httpService: HttpService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadProfiles();
  }

  handleClick(profile: TransportCreationProfileSight) {

    var data = JSON.parse(this.actionItem.data);

    if (data.entranceIds.length == 1) {
      this.dialogService.showConfirm('tmc-yard.ui.action-tablet.create-transport-by-profile.confirm-title', 'tmc-yard.ui.action-tablet.create-transport-by-profile.confirm-description').afterClosed().subscribe(result => {
        if (result) {
          this.createTransportByProfileAndEntrance(profile.id, data.entranceIds[0]).subscribe(() => { });
        }
      });
    } else {
      // TODO show Selection Dialog of more than one entrance available
    }

  }

  private createTransportByProfileAndEntrance(profileId: number, entranceId: number): AsyncSubject<void> {
    const subject = new AsyncSubject<void>();
    this.httpService.postWithContext(environment.tmcBaseUrl + '/tmc-yard/control/actionTabletTransportCreationProfile/createTransportByProfileAndEntrance', { profileId: profileId, entranceId: entranceId }).subscribe(response => {
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }

  private loadProfiles(): AsyncSubject<void> {
    
    var data = JSON.parse(this.actionItem.data);

    const subject = new AsyncSubject<void>();
    this.httpService.postWithContext<Array<TransportCreationProfileSight>>(environment.tmcBaseUrl + '/tmc-yard/control/actionTabletTransportCreationProfile/getProfilesByIds', data.profileIds).subscribe(response => {
      let profiles = new Array<TransportCreationProfileSight>();
      for (const transport of response) {
        profiles.push(new TransportCreationProfileSight(transport));
      }
      this.profiles = profiles;
      subject.next();
      subject.complete();
    }, error => {
      subject.error('');
    });
    return subject;
  }


}
